import { useFlags } from "launchdarkly-react-client-sdk";
import { useCallback } from "react";
import { Icon } from "../../../components/Icon/Icon.tsx";
import {
  COPY_AD_TOOL,
  EDIT_IMAGE_TOOL,
  EDIT_SHAPE_TOOL,
  EDIT_TEXT_TOOL,
} from "../../../routes.ts";
import { ToolbarActionItem } from "../components/Toolbar/ToolbarActionItem.tsx";
import { useSelectedTool } from "../hooks/useSelectedTool.ts";
import type { DesignerTool } from "../types.ts";
import { designerCanvasStore } from "../Workspaces/EditWorkspace/Designer/stores/designerCanvasStore.ts";

export const EditToolsToolbar = () => {
  const { selectedTool, setSelectedTool } = useSelectedTool();

  const onClick = useCallback(
    (tool: DesignerTool) => {
      setSelectedTool(selectedTool === tool ? undefined : tool);
      designerCanvasStore.deselectLayers();
    },
    [selectedTool, setSelectedTool],
  );

  const flags = useFlags();

  return (
    <div className="flex-col items-center h-full w-full overflow-y-auto overflow-x-clip scrollbar-hide">
      <ToolbarActionItem
        onClick={() => onClick(EDIT_TEXT_TOOL)}
        isActive={selectedTool === EDIT_TEXT_TOOL}
        title="Text"
      >
        <Icon name="Type" size="sm" />
      </ToolbarActionItem>
      <ToolbarActionItem
        onClick={() => onClick(EDIT_SHAPE_TOOL)}
        isActive={selectedTool === EDIT_SHAPE_TOOL}
        title="Shape"
      >
        <Icon name="Shapes" size="sm" />
      </ToolbarActionItem>
      <ToolbarActionItem
        onClick={() => onClick(EDIT_IMAGE_TOOL)}
        isActive={selectedTool === EDIT_IMAGE_TOOL}
        title="Image"
      >
        <Icon name="Image" size="sm" />
      </ToolbarActionItem>
      {flags["copyAdBetaProgram"] && (
        <>
          <div className="h-025 w-1000 border-t-025" />
          <ToolbarActionItem
            onClick={() => onClick(COPY_AD_TOOL)}
            isActive={selectedTool === COPY_AD_TOOL}
            title="Copy ad"
            isBeta
          >
            <Icon name="Images" size="sm" />
          </ToolbarActionItem>
        </>
      )}
    </div>
  );
};
